import { ClientFilterReferencesApiAdapter } from '@shared/adapters/ClientFilterReferencesApiAdapter';
import { HttpClient } from '@shared/adapters/HttpClient';

export interface TeamChild {
  id: number;
  name: string;
}

export class TeamsApiAdapter {
  constructor(private httpClient: HttpClient) {}

  async getTeamsChild(): Promise<TeamChild[]> {
    const references = new ClientFilterReferencesApiAdapter(this.httpClient, 'billing');
    if (references.usesContextualReferences) return references.getAll();
    const response = await this.httpClient.get<{ data: TeamChild[] }>('/teams-child');
    return response.data;
  }
}
